import { reactive } from 'vue'

export const eventBus = reactive({
  showContactModal: false,
  showServiceModal: false,
  serviceModalData: { title: '', description: '' },
  sidebarOpen: false,
  triggerLangChange: null
})
